import { CurrencyAmount } from '~/components/component-library'
import { SponsoredBadge } from '~/components/txn-display/cost-display/SponsoredBadge'
import { cn } from '~/utils/tailwind-utils'

type SponsoredFeeAmountProps = {
  cost: number
  isSponsored: boolean
  hideBadgeText?: boolean
}

export const SponsoredFeeAmount = ({
  cost,
  isSponsored,
  hideBadgeText = false,
}: SponsoredFeeAmountProps) => (
  <>
    {isSponsored && <SponsoredBadge hideText={hideBadgeText} />}
    <span
      className={cn({
        'text-secondary line-through': isSponsored,
      })}
    >
      ~<CurrencyAmount layout="inline" value={cost} />
    </span>
  </>
)
